export const AVAILABLE_WEIGHT_TYPES = {
  Bold: 'bold',
  Light: '300',
  Thin: '400',
  Medium: '500',
  Regular: 'normal',
  VeryBig: '900',
};
